import type { LucideIcon } from 'lucide-react'
import type { ModuleId } from '@/types'

import {
    BookOpen,
    Briefcase,
    LayoutDashboard,
    Route,
    Store
} from 'lucide-react'

export const MODULE_ICONS: Record<ModuleId, LucideIcon> = {
    'student-hub': LayoutDashboard,
    journey: Route,
    'study-vault': BookOpen,
    placements: Briefcase,
    marketplace: Store
}
